var map = {
	"./basel.png": 5970,
	"./bern.png": 388,
	"./biel.png": 615,
	"./genf.png": 2271,
	"./lausanne.png": 2592,
	"./lugano.png": 4895,
	"./luzern.png": 3013,
	"./stgallen.png": 2799,
	"./winterthur.png": 7041,
	"./zurich.png": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;